module.exports = __webpack_public_path__ + "static/images/grab-logo.3dgAlp8.svg";